<template>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
        <el-form ref="customInfo" label-width="110px" label-position="right" class="pay-form">
            <el-form-item label="备注">
                <el-input v-model="remarks" placeholder="请输入凭证备注"></el-input>
            </el-form-item>
            <el-form-item label="凭证图片">
                <el-tooltip class="item" effect="dark" content="此收款方式不能关联订单支付状态，需要人工审核" placement="top">
                    <el-upload class="avatar-uploader" :action="`${baseUrl}/file/upload/image`" :file-list="fileList"
                        list-type="picture-card" :on-success="handleAvatarSuccess" :headers="headers"
                        :on-remove="remove" accept="image/jpg,image/jpeg,image/png">
                        <i class="el-icon-plus"></i>
                        <!-- <img v-if="customUrl" :src="resolveImg(customUrl)" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon" /> -->
                    </el-upload>
                </el-tooltip>
            </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="handleSetModal">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { getToken } from "@/utils/auth";
import { resolveImg } from "@/utils/imgFill";
import { uploadPayImage } from "@/api/common";
export default {
    props: {
        pvData: {
            type: Object,
            default: {
                id: 0,
                pvShow: false,
            },
        }
    },
    data() {
        return {
            fileList: [],
            headers: { Authorization: getToken() },
            dialogVisible: false,
            customUrl: '',
            remarks: '',
        }
    },
    watch: {
        pvData: {
            deep: true,
            handler(val) {
                console.log(val.pvShow);
                if (val.pvShow) {
                    this.remarks = ''
                    this.customUrl = ''
                    this.fileList = []
                    this.dialogVisible = val.pvShow;
                } else {
                    this.dialogVisible = false;
                }

            }
        }
    },
    methods: {
        resolveImg,
        handleClose() {
            this.$emit('paymentVoucherClose');
        },
        remove(item, newItem) {
            console.log(item, newItem);
            if (item, newItem.length === 0) {
                this.customUrl = ''
            }
        },
        handleAvatarSuccess(elData, file, fileList) {
            let el = elData.data
            this.customUrl = el.accessAddress;
            // this.applyModule.formList["customChat"] = el.accessAddress;
            // this.$message.success("收款码上传成功");
            if (fileList.length > 1) {
                console.log(el, file, fileList, this.fileList);
                fileList.pop()
                fileList[0].url = this.resolveImg(el.accessAddress)
            }
        },
        handleSetModal() {
            if(!this.remarks){
                this.$message.error("请输入凭证备注")
                return
            }
            if(!this.customUrl){
                this.$message.error("请上传凭证图片")
                return
            }
            uploadPayImage({
                orderId: this.pvData.orderId,
                id: this.pvData.id,
                payImage: this.customUrl,
                remarks: this.remarks,
            })
                .then((res) => {
                    console.log(res);
                    this.customsVisible = false;
                    this.$message.success("上传成功");
                    this.$emit('paymentVoucherClose');
                });




        },
    }
}
</script>

<style scoped lang="scss"></style>
